import React, { useEffect, useState } from "react";

export default function PassengerAvatar({ photoURL, name, className = "", style, imageAlt = "Foto de perfil" }) {
  const [imageFailed, setImageFailed] = useState(false);
  const initial = (name || "U").trim().charAt(0).toUpperCase() || "U";

  useEffect(() => {
    setImageFailed(false);
  }, [photoURL]);

  return (
    <div className={`zuno-passenger-avatar ${className}`.trim()} style={style} aria-label={`Avatar de ${name || "usuário"}`}>
      {photoURL && !imageFailed ? (
        <img src={photoURL} alt={imageAlt} onError={() => setImageFailed(true)} />
      ) : (
        <span aria-hidden="true">{initial}</span>
      )}
    </div>
  );
}
